import { api } from '@/lib/api';
import type { AdvanceFulfillmentInput, CremationFulfillment } from './types';

// ---- Vendor (provider) ----
export async function get_vendor_fulfillment(booking_id: string): Promise<CremationFulfillment> {
  const res = await api.get<CremationFulfillment>(`/vendor/bookings/${booking_id}/cremation`);
  return res.data;
}

export async function advance_fulfillment(
  booking_id: string,
  input: AdvanceFulfillmentInput,
): Promise<CremationFulfillment> {
  const res = await api.post<CremationFulfillment>(`/vendor/bookings/${booking_id}/cremation/advance`, input);
  return res.data;
}

// ---- Owner ----
export async function get_owner_fulfillment(booking_id: string): Promise<CremationFulfillment> {
  const res = await api.get<CremationFulfillment>(`/user/bookings/${booking_id}/cremation`);
  return res.data;
}
